import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { dataLayerSendEvent } from '@common/Utility/analytics-utils';
import { getImageSrc, MIN_MOBILE_WIDTH, getReplaceHtmlTags } from '@common/Utility/common-utils';
import { PAGE_TITLES, TELECONSULT_ROUTE } from '@common/Utility/constants';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { BannerConsultationStyled } from './BannerConsultationStyled';
import { instantGPBannerImpression, instantGPBannerClick } from 'TeleConsultation/InstantGP/InstantGpAnalytics/instantGpAnalytics';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const BannerConsultation = (props) => {
  const { data, analyticsProps } = props;
  const router = useRouter();
  const generateURL = useNavigationURL();
  const [windowWidth, setWindowWidth] = useState();
  const inView = useRef(0);

  const navigate = (e, item) => {
    e?.preventDefault();
    if (props?.instantGP) {
      instantGPBannerClick(props?.screen);
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/instantgp/details`),
        query:{
          referrerPage: props?.category
        }
      });
    } else {
      const bannerProps = {
        banner_name: 'Quick Booking',
        banner_url: item?.file,
        banner_position: '1',
        banner_page_slot: 'Middle',
        banner_id: 'Quick Booking',
        banner_title: 'Quick Booking',
      };
      const specificProps = {
        screen_name: props?.pageName,
        oneaster_category: props?.category,
      };
      if (analyticsProps && Object.keys(analyticsProps).length !== 0) {
        dataLayerSendEvent('banner_click', { ...analyticsProps, ...bannerProps });
      } else {
        dataLayerSendEvent('banner_click', { ...specificProps, ...bannerProps });
      }

      const properties = {
        type: 'Quick Booking',
      };
      sendEventToSmartLook('banner_click', properties);
      if (item?.linkWeb !== '') {
        if (item?.linkWeb.indexOf('http') === -1) {
          if (item?.linkWeb.includes('?')) {
            router.push({
              pathname: generateURL(item?.linkWeb.split('?')[0]),
              query: item?.linkWeb.split('?')[1],
            });
          } else {
            router.push({
              pathname: generateURL(item?.linkWeb),
              query: { id: props?.screen },
            });
          }
        } else {
          window.open(generateURL(item?.linkWeb), '_self');
        }
      }
    }
  };

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    if(props?.instantGP && inView.current === 0) {
      instantGPBannerImpression(props?.screen);
      inView.current = 1;
    };
  }, []);

  const getUrl = () => {
    let url = '';
    if (props?.instantGP) {
      url = generateURL(`${TELECONSULT_ROUTE}/instantgp/details`);
    } else {
      url = generateURL(`${TELECONSULT_ROUTE}/quickbooking?id=Core`);
    }
    return url;
  };

  return (
    <BannerConsultationStyled className={props?.outerClass}>
      <Container>
        {data !== undefined && data?.length !== 0 && (
          <>
            {data?.map((item, i) => {
              return (
                <a href={getUrl()} onClick={(e)=> navigate(e,item)}>
                  <div
                    key={item.order}
                    className="banner"
                  >
                    <Image
                      src={windowWidth <= MIN_MOBILE_WIDTH ? getImageSrc(item.imageMobile) : getImageSrc(item.imageWeb)}
                      alt={PAGE_TITLES?.ASTER_HOME}
                      title={PAGE_TITLES?.ASTER_HOME}
                      layout="fill"
                    />
                  </div>
                </a>
              );
            })}
          </>
        )}
      </Container>
    </BannerConsultationStyled>
  );
};

BannerConsultation.defaultProps = {
  instantGP: false,
};

BannerConsultation.propTypes = {
  guest: PropTypes.bool,
  data: PropTypes.any,
  outerClass: PropTypes.string,
  screen: PropTypes.string,
  pageName: PropTypes.string,
  category: PropTypes.string,
  instantGP: PropTypes.bool,
  analyticsProps: PropTypes.object,
};
export default BannerConsultation;
